<template>
    <b-modal id="users_filter"
             v-bind:no-close-on-backdrop=true
             v-model="show" size="xl" title="Редагування">

        <b-card no-body>
            <vue-editor :editor-toolbar="editor_rules"  id="current_text" v-model="text_ed"></vue-editor>
        </b-card>

        <template slot="modal-footer" slot-scope="{ ok, cancel }">
            <b-spinner variant="success" v-if="show_action"></b-spinner>

            <b-button size="xl" variant="outline-primary" @click.prevent="close_editor()" class="btn btn-lg  waves-effect waves-themed mr-3">
                <i class="fal fa-check mr-1"></i>
                Гаразд
            </b-button>
        </template>
    </b-modal>
</template>

<script>
    import { VueEditor } from "vue2-editor";
    export default {
        name: "editor",
        components : {
            VueEditor
        },


        data() {
            return  {
                show : false,
                show_action : false,
                text_uniq : "",
                text_ed : "",
                editor_rules :[
                    ["bold", "italic", "underline","link"],
                    [{ align: "center" }, { align: "right" },{ align: "justify" }],
                    [{ list: "ordered" }, { list: "bullet" },{ list: "check" }],
                ],

            }
        },
        created() {
            EventBus.$on('load_editor', e => {
                this.text_ed = e.message;
                this.text_uniq = e.uniq;

                this.show = true;
            });
        },

        methods : {
            close_editor() {
                EventBus.$emit('finish_edit',{
                    'text':this.text_ed,
                    'uniq':this.text_uniq
                });
                this.show = false;

            }
        },

    }
</script>

<style scoped>

</style>
